import { Components, Theme } from '@mui/material';

export const cssBaselineOverrides: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: () => ({
    '#root': {
      isolation: 'isolate',
    },
  }),
};
